<template>
  <div id="app">
    <nav-bar v-if="isAuthenticated"></nav-bar>
    <div class="container">
      <router-view />
    </div>
    <!-- <bottom-bar v-if="isAuthenticated"></bottom-bar> -->
  </div>
</template>

<script>
const NavBar = () => import("@/components/NavBar.vue");
// import BottomBar from "@/components/BottomBar.vue";
import { mapGetters } from "vuex";

import language from "@/mixins/language";
import toast from "@/mixins/toast";

export default {
  mixins: [language, toast],
  components: {
    NavBar,
  },
  computed: {
    ...mapGetters("authentication", ["isAuthenticated"]),
  },
  created() {
    this.setStoredLanguage();

    // Detect update and show message
    document.addEventListener(
      "swUpdated",
      () => {
        this.$buefy.snackbar.open({
          message: this.$t("update.newVersionDetected"),
          position: "is-top",
          actionText: this.$t("update.reload"),
          indefinite: true,
          onAction: () => {
            window.location.reload(true);
          },
        });
      },
      { once: true }
    );
  },
};
</script>
